export default __webpack_public_path__ + "static/media/logo_b.e594dd62.svg";